<!-- Dashboard Header -->
<div class="dash-header">
    <div class="dash-header-left">
        <h1 class="dash-title">Dashboard</h1>
        <span class="dash-date-display">{{date}}</span>
    </div>
    <div class="dash-header-right">
        <label class="date-label">Date</label>
        <input type="date" class="date-input" [(ngModel)]="date" (change)="inputchange()" [max]="today" />
        <span class="text-muted small" style="opacity:.5; margin-left:6px;" *ngIf="configuration?.timezone || configuration?.currency">{{configuration.timezone ? 'UTC' + configuration.timezone : ''}}{{configuration.timezone && configuration.currency && configuration.currency !== 'none' ? ' · ' : ''}}{{configuration.currency && configuration.currency !== 'none' ? configuration.currency : ''}}</span>
    </div>
</div>

<!-- Loading Bar -->
<div class="loading-bar" *ngIf="is_loading">
    <div class="loading-bar-inner"></div>
</div>


<!-- Bank Summary -->
<div class="dash-card">
    <div class="dash-card-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 .95 14.61 4H1.39zM1 5.5V6h14v-.5zM1 14h14v.5H1z"/>
            <path d="M2 7v6h1V7zm4 0v6h1V7zm4 0v6h1V7zm4 0v6h1V7z"/>
        </svg>
        <h2>Bank Summary</h2>
    </div>
    <div class="dash-table-wrap">
        <table class="dash-table">
            <thead>
                <tr>
                    <th class="col-name">Bank</th>
                    <th class="col-num">Opening</th>
                    <th class="col-num">Debit/In Adj</th>
                    <th class="col-num">Credit/Out Adj</th>
                    <th class="col-num">Tips</th>
                    <th class="col-num">Profit</th>
                    <th class="col-num">Debit/In</th>
                    <th class="col-num">Credit/Out</th>
                    <th class="col-num">GW Fees</th>
                    <th class="col-num col-highlight">Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="is_loading">
                    <td colspan="10" class="state-cell">
                        <span class="state-text">Loading...</span>
                    </td>
                </tr>
                <tr *ngIf="!is_loading && summary_bank.length == 0">
                    <td colspan="10" class="state-cell">
                        <span class="state-text">No Data Available</span>
                    </td>
                </tr>
                <tr *ngFor="let bank of summary_bank">
                    <td class="col-name">
                        <a class="row-link" [routerLink]="['/lo', profile_uuid, 'bank','report', bank.uuid]" [queryParams]="{date: date}">{{bank.title}}</a>
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.opening_balance ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.debit_adj_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.credit_adj_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.tips_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.profit_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.debit_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.credit_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.gw_fees ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.uc_sum ?? 0) | number: '1.2-2'}}
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="!is_loading && summary_bank.length > 0">
                <tr>
                    <td class="col-name foot-label">Total</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'opening_balance') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'debit_adj_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'credit_adj_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'tips_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'profit_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'debit_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'credit_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'gw_fees') | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'uc_sum') | number: '1.2-2'}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<!-- Seamless Game Summary -->
<div class="dash-card">
    <div class="dash-card-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.93.93 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.93.93 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a25 25 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135"/>
            <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5"/>
        </svg>
        <h2>Seamless Game Summary</h2>
    </div>
    <div class="dash-table-wrap">
        <table class="dash-table">
            <thead>
                <tr>
                    <th class="col-name">Game</th>
                    <th class="col-num">Debit/In</th>
                    <th class="col-num">Credit/Out</th>
                    <th class="col-num col-highlight">Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="is_loading">
                    <td colspan="4" class="state-cell">
                        <span class="state-text">Loading...</span>
                    </td>
                </tr>
                <tr *ngIf="!is_loading && summary_seemless.length == 0">
                    <td colspan="4" class="state-cell">
                        <span class="state-text">No Data Available</span>
                    </td>
                </tr>
                <tr *ngFor="let game of summary_seemless">
                    <td class="col-name">{{game.title}}</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.bet ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.winloss ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.balance ?? 0) | number: '1.2-2'}}
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="!is_loading && summary_seemless.length > 0">
                <tr>
                    <td class="col-name foot-label">Total</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_seemless', 'bet') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_seemless', 'winloss') | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_seemless', 'balance') | number: '1.2-2'}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<!-- Manual / Transfer Wallet Game Summary -->
<div class="dash-card">
    <div class="dash-card-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
            <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z"/>
        </svg>
        <h2>Manual / Transfer Wallet Game Summary</h2>
    </div>
    <div class="dash-table-wrap">
        <table class="dash-table">
            <thead>
                <tr>
                    <th class="col-name">Game</th>
                    <th class="col-num">Opening</th>
                    <th class="col-num">Debit/In Adj</th>
                    <th class="col-num">Credit/Out Adj</th>
                    <th class="col-num">Bonus</th>
                    <th class="col-num">Debit/In</th>
                    <th class="col-num">Credit/Out</th>
                    <th class="col-num col-highlight">Balance</th>
                    <th class="col-num">In - Out - Bonus</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="is_loading">
                    <td colspan="9" class="state-cell">
                        <span class="state-text">Loading...</span>
                    </td>
                </tr>
                <tr *ngIf="!is_loading && summary_game.length == 0">
                    <td colspan="9" class="state-cell">
                        <span class="state-text">No Data Available</span>
                    </td>
                </tr>
                <tr *ngFor="let game of summary_game">
                    <td class="col-name">{{game.title}}</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.opening_balance ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.debit_adj_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.credit_adj_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.bonus_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.debit_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.credit_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.balance ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(game.dc_sum ?? 0) | number: '1.2-2'}}
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="!is_loading && summary_game.length > 0">
                <tr>
                    <td class="col-name foot-label">Total</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'opening_balance') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'debit_adj_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'credit_adj_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'bonus_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'debit_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'credit_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'balance') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_game', 'dc_sum') | number: '1.2-2'}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<!-- Unknown Payment Summary -->
<div class="dash-card">
    <div class="dash-card-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0m1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.7 1.7 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627"/>
        </svg>
        <h2>Unknown Payment Summary</h2>
    </div>
    <div class="dash-table-wrap">
        <table class="dash-table">
            <thead>
                <tr>
                    <th class="col-name">Bank</th>
                    <th class="col-num">Daily Unclaim</th>
                    <th class="col-num">Daily Claimed</th>
                    <th class="col-num col-highlight">Total Unclaim Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="is_loading">
                    <td colspan="4" class="state-cell">
                        <span class="state-text">Loading...</span>
                    </td>
                </tr>
                <tr *ngIf="!is_loading && summary_bank.length == 0">
                    <td colspan="4" class="state-cell">
                        <span class="state-text">No Data Available</span>
                    </td>
                </tr>
                <tr *ngFor="let bank of summary_bank">
                    <td class="col-name">{{bank.title}}</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.upt_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.upc_sum ?? 0) | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{(bank.upb_sum ?? 0) | number: '1.2-2'}}
                    </td>
                </tr>
            </tbody>
            <tfoot *ngIf="!is_loading && summary_bank.length > 0">
                <tr>
                    <td class="col-name foot-label">Total</td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'upt_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'upc_sum') | number: '1.2-2'}}
                    </td>
                    <td class="col-num col-highlight">
                        <span class="currency" *ngIf="!configuration.hide_dashboard_currency && configuration.currency != 'none'">{{configuration.currency}}</span>
                        {{summary('summary_bank', 'upb_sum') | number: '1.2-2'}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<div class="text-muted small text-end py-2 px-3" style="opacity:.45" *ngIf="configuration?.timezone || configuration?.currency">All figures in UTC{{configuration.timezone || '+08:00'}}{{configuration.currency && configuration.currency !== 'none' ? ' · ' + configuration.currency : ''}}</div>

<app-credit-collection [compact]="true" [consolidated]="false" [refreshKey]="is_loading"></app-credit-collection>

<app-dashboard-withdrawals [date]="date" [refreshKey]="is_loading"></app-dashboard-withdrawals>
